import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Grid, Input, Dropdown, Button, Icon} from 'semantic-ui-react';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {toUpperCase} from '../../../common/util/fieldsNormalization';
import {parseZones} from '../../../common/util/options';
import {viewOptions} from '../../../common/constants/lists';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';
import WarehouseLocationsTable from './table';
import './list.scss';

const INITIAL_STATE = {
  'viewType': 'all',
  'warehouse': 'CPD',
  'pickingZone': '',
  'location': '',
  'partCode': '',
};

class WarehouseLocationsList extends Component {
  constructor(props) {
    super(props);
    this.state = INITIAL_STATE;

    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.handleDownloadClick = this.handleDownloadClick.bind(this);
    this.handleButtonClick = this.handleButtonClick.bind(this);
    this.resetFilters = this.resetFilters.bind(this);
  }

  componentDidMount() {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.WarehouseLocations,
        scopes.See
      )
    ) {
      this.props.navigateTo(paths.AccessDenied);
    }
    this.props.resetWarehouseAllocations();
    this.props.clearSelectedLocations();
    this.props.fetchWarehouses();
    this.props.fetchZonesList();
  }

  componentDidUpdate(prevProps, prevState) {
    const {pageNumber, pageSize, updateTable} = this.props;

    if (
      pageNumber !== prevProps.pageNumber ||
      pageSize !== prevProps.pageSize
    ) {
      const urlParams = this.buildAllocationsParams(pageSize, pageNumber);
      this.props.getWarehouseAllocations(this.state.warehouse, urlParams);
    }
    if (updateTable !== prevProps.updateTable) {
      const urlParams = this.buildAllocationsParams(pageSize, pageNumber);
      this.props.getWarehouseAllocations(this.state.warehouse, urlParams);
    }
  }

  parseWarehouses(warehouses, permissions) {
    const filteredWarehouses = warehouses.filter((item) =>
      hasAccessPermission(permissions, `Bodega ${item.code}`, scopes.Edit)
    );

    return filteredWarehouses.map((item) => ({
      'text': item.code,
      'value': item.code,
    }));
  }

  handleFilterChange(event, target) {
    const {name, value} = target;
    const specialField = name === 'location' || name === 'partCode';
    const updatedState = {...this.state};
    updatedState[name] = specialField ? toUpperCase(value) : value;

    this.setState(updatedState);
  }

  resetFilters() {
    this.setState(INITIAL_STATE);
    this.props.resetWarehouseAllocations();
  }

  buildAllocationsParams(limit, offset) {
    const {viewType, pickingZone, location, partCode} = this.state;
    const params = {
      pickingZone,
      'location': location,
      'partCode': partCode,
    };

    if (limit) {
      params.limit = limit;
    }
    if (offset || offset === 0) {
      params.offset = offset;
    }
    if (viewType && viewType !== 'all') {
      params.withStock = viewType;
    }

    return params;
  }

  handleDownloadClick() {
    const urlParams = this.buildAllocationsParams(null, null);
    this.props.downloadWarehouseAllocations(this.state.warehouse, urlParams);
  }

  handleButtonClick() {
    const {pageSize, pageNumber} = this.props;
    const urlParams = this.buildAllocationsParams(pageSize, pageNumber);
    this.props.getWarehouseAllocations(this.state.warehouse, urlParams);
  }

  renderWarehouseSelector() {
    const {loadingWarehouses, warehouses, permissions} = this.props;

    return (
      <Dropdown
        fluid
        selection
        name='warehouse'
        options={this.parseWarehouses(warehouses, permissions)}
        value={this.state.warehouse}
        onChange={this.handleFilterChange}
        disabled={loadingWarehouses}
      />
    );
  }

  renderZoneSelector() {
    const {loadingZones, zones} = this.props;

    return (
      <Dropdown
        fluid
        selection
        name='pickingZone'
        options={parseZones(zones)}
        value={this.state.pickingZone}
        onChange={this.handleFilterChange}
        loading={loadingZones}
      />
    );
  }

  render() {
    const {
      loadingZones,
      loadingWarehouses,
      loadingAllocations,
      downloadingAllocations,
    } = this.props;
    const searchEnabled =
      loadingZones ||
      loadingWarehouses ||
      loadingAllocations ||
      downloadingAllocations;

    return (
      <div className='warehouse-locations-list'>
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <h2>Maestro de Ubicaciones</h2>
              <div className='title-bar-actions'>
                <Button
                  onClick={this.resetFilters}
                  disabled={searchEnabled}
                  secondary
                >
                  Limpiar
                </Button>
                <Button
                  onClick={this.handleDownloadClick}
                  className='download'
                  primary
                  disabled={searchEnabled}
                  loading={downloadingAllocations}
                >
                  <Icon name='download' />
                  <span>Excel</span>
                </Button>
                <Button
                  onClick={this.handleButtonClick}
                  disabled={searchEnabled}
                  loading={loadingAllocations}
                  primary
                >
                  Buscar
                </Button>
              </div>
            </div>
            <div className='filters-section'>
              <Grid>
                <Grid.Row columns={10} verticalAlign='middle'>
                  <Grid.Column width={1} textAlign='left'>
                    <h5>Ver</h5>
                  </Grid.Column>
                  <Grid.Column width={2}>
                    <Dropdown
                      fluid
                      selection
                      name='viewType'
                      options={viewOptions}
                      value={this.state.viewType}
                      onChange={this.handleFilterChange}
                    />
                  </Grid.Column>
                  <Grid.Column width={1} textAlign='left'>
                    <h5>Bodega</h5>
                  </Grid.Column>
                  <Grid.Column width={2}>
                    {this.renderWarehouseSelector()}
                  </Grid.Column>
                  <Grid.Column width={1} textAlign='left'>
                    <h5>Zona</h5>
                  </Grid.Column>
                  <Grid.Column width={2}>
                    {this.renderZoneSelector()}
                  </Grid.Column>
                  <Grid.Column width={1} textAlign='left'>
                    <h5>Ubicación</h5>
                  </Grid.Column>
                  <Grid.Column width={2}>
                    <Input
                      fluid
                      name='location'
                      value={this.state.location}
                      onChange={this.handleFilterChange}
                      maxLength='12'
                    />
                  </Grid.Column>
                  <Grid.Column width={1} textAlign='left'>
                    <h5>Código Item</h5>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <Input
                      name='partCode'
                      value={this.state.partCode}
                      onChange={this.handleFilterChange}
                      maxLength='15'
                      fluid
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </div>
          </div>
        </Card>
        <WarehouseLocationsTable warehouse={this.state.warehouse} />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'permissions': state.session.permissions,
    'loadingZones': state.zones.loading,
    'zones': state.zones.list || [],
    'loadingWarehouses': state.warehouses.loading,
    'warehouses': state.warehouses.list || [],
    'pageNumber': state.warehouseAllocations.offset,
    'pageSize': state.warehouseAllocations.limit,
    'loadingAllocations': state.warehouseAllocations.loading,
    'downloadingAllocations': state.warehouseAllocations.downloading,
    'updateTable': state.warehouseAllocations.updateTable,
  };
};

const {
  fetchZonesList,
  fetchWarehouses,
  getWarehouseAllocations,
  downloadWarehouseAllocations,
  resetWarehouseAllocations,
  clearSelectedLocations,
  navigateTo,
} = Actions;

export default connect(mapStateToProps, {
  fetchZonesList,
  fetchWarehouses,
  getWarehouseAllocations,
  downloadWarehouseAllocations,
  resetWarehouseAllocations,
  clearSelectedLocations,
  navigateTo,
})(WarehouseLocationsList);
